import api from "../utils/api";
import { API_ENDPOINTS, ApiResponse } from "@/constants/api";

// 사용자 정보 인터페이스
export interface UserInfo {
    loginId: string;
    nickname: string;
    gender: string;
    isRegistered: boolean;
    isMarketingConsent: boolean;
    loginAt: string;
    createdAt: string;
}

// 사용자 정보 조회
export const fetchUserInfo = async (): Promise<UserInfo> => {
    try {
        const response = await api.get<ApiResponse<UserInfo>>(API_ENDPOINTS.USER_ME);
        return response.data.data;
    } catch (error) {
        console.error("Failed to fetch user info:", error);
        throw error;
    }
};

// 로그아웃
export const logout = async (): Promise<void> => {
    try {
        await api.post(API_ENDPOINTS.LOGOUT);
    } catch (error) {
        console.error("Failed to logout:", error);
        throw error;
    }
};

// 회원탈퇴
export const withdraw = async (): Promise<void> => {
    try {
        await api.delete(API_ENDPOINTS.AUTH);
    } catch (error) {
        console.error("Failed to withdraw account:", error);
        throw error;
    }
};

export default {
    fetchUserInfo,
    logout,
    withdraw
};
